import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { CheckCircleOutlineOutlined } from '@mui/icons-material';
import Container from '../../components/LandingPage/Container';
import { useNavigate } from 'react-router-dom';

/* eslint-disable react/prop-types */

const VantageCard: React.FC<{ title: string; description: string }> = ({ title, description }) => {
  return (
    <Box
      height={{ xs: '100%', md: '186px' }}
      display="flex"
      flexDirection="column"
      gap="11px"
      padding="21px 11px"
      sx={{ border: '1px solid var(--acer-green)' }}
      bgcolor="white"
    >
      <CheckCircleOutlineOutlined width="24px" height="24px" sx={{ color: 'var(--acer-green)' }} />
      <Typography fontSize="16px" fontWeight="500" lineHeight="24px" letterSpacing="0.15px">
        {title}
      </Typography>
      <Typography fontSize="16px" fontWeight="400" lineHeight="24px" letterSpacing="0.15px">
        {description}
      </Typography>
    </Box>
  );
};

const Vantages: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigateToLogin = () => {
    const el = document.getElementById('login');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const vantageCards = [
    {
      title: 'Comissões atrativas',
      description:
        'Ganhe por cada transação e aumente sua margem com a modalidade de assinatura mensal.',
    },
    {
      title: 'Plataforma digital inteligente',
      description: 'Gestão de cotações, pedidos, clientes e oportunidades, tudo em um só lugar.',
    },
  ];

  const vantageCards2 = [
    {
      icon: (
        <CheckCircleOutlineOutlined
          width="24px"
          height="24px"
          sx={{ color: 'var(--acer-green)' }}
        />
      ),
      title: 'Faturamento direto da fábrica',
      description: 'Entrega rápida e sem intermediários.',
    },
    {
      icon: (
        <CheckCircleOutlineOutlined
          width="24px"
          height="24px"
          sx={{ color: 'var(--acer-green)' }}
        />
      ),
      title: 'Suporte e materiais de venda',
      description:
        'Acesso a apresentações, fichas técnicas, vídeos e campanhas para escalar sua atuação consultiva.',
    },
  ];

  return (
    <Box bgcolor="#F2F2F7" padding="41px 0">
      <Container>
        <Box display="flex" flexDirection="column" gap="29px" width="100%">
          <Typography fontSize="28px" fontWeight="400" lineHeight="36px" letterSpacing="0">
            Vantagens para a sua revenda
          </Typography>
          <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap="29px" width="100%">
            <Box
              display="flex"
              flexDirection="column"
              gap="29px"
              margin={{ xs: '0 auto', md: '0' }}
              width={{ xs: '100%', md: '50%' }}
            >
              {vantageCards.map(vantageCard => (
                <VantageCard
                  key={vantageCard.title}
                  title={vantageCard.title}
                  description={vantageCard.description}
                />
              ))}
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              gap="29px"
              margin={{ xs: '0 auto', md: '0' }}
              width={{ xs: '100%', md: '50%' }}
            >
              {vantageCards2.map(vantageCard => (
                <VantageCard
                  key={vantageCard.title}
                  title={vantageCard.title}
                  description={vantageCard.description}
                />
              ))}
            </Box>
          </Box>
          <Box
            display="flex"
            flexDirection={{ xs: 'column', md: 'row' }}
            gap="29px"
            margin={{ xs: '0 auto', md: '0' }}
            width="100%"
          >
            <Button
              variant="contained"
              color="primary"
              sx={{
                width: '100%',
                fontWeight: '500',
                color: 'white',
                '&:hover': { backgroundColor: 'var(--acer-green)', color: 'white' },
              }}
              onClick={() => navigate('/register')}
            >
              <Typography>Quero ser revendedor</Typography>
            </Button>
            <Button
              variant="contained"
              sx={{
                backgroundColor: 'var(--acer-dark)',
                width: '100%',
                fontWeight: '500',
                color: 'white',
                '&:hover': { backgroundColor: 'var(--acer-mediumgray)', color: 'white' },
              }}
              onClick={() => {
                handleNavigateToLogin();
              }}
            >
              <Typography>Ir para Loja do Revendedor</Typography>
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Vantages;
